import z from "zod";

export const customerPriceLevelTabSchema = z.object({
  priceLevelId: z.string().uuid(),
  accountId: z.string().uuid(),
});
